import { render } from "./dialog-detail.vue?vue&type=template&id=469b07b9&scoped=true&ts=true"
import script from "./dialog-detail.vue?vue&type=script&lang=ts"
export * from "./dialog-detail.vue?vue&type=script&lang=ts"

import "./dialog-detail.vue?vue&type=style&index=0&id=469b07b9&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469b07b9"]])

export default __exports__